import { connect } from "react-redux";
import { ResultsComparisonPhotosynthesis as Component } from "./ResultsComparisonPhotosynthesis";
import {} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  // TODO: Need to be fixed after the protocol Section Implementation.
  return {
    colorPrediction: {
      id: 1004,
      type: "COLOR_PREDICTION",
      text: "Using the same 4 tubes from above, imagine you turn on the light and let the experiment run for 12 hours. Predict the outcome by assigning the correct final pH indicator color to the tubes.",
      question: "Select the buttons below each tube to predict a color.",
      options: [
        {
          optionLabel: "",
          optionTube: {
            type: "GLASS_TUBE",
            solution: "#4a663c",
            stopperId: 1,
            tubeLabel: "1",
          },
          checkboxes: [
            {
              name: "Tube one option one",
              value: "green",
              checked: false,
              label: "Green",
              style: {
                backgroundColor: "#4a663c",
                color: "white",
              },
            },
            {
              name: "Tube one option two",
              value: "yellow",
              checked: false,
              label: "Yellow",
              style: {
                backgroundColor: "#d1b93d",
                color: "black",
              },
            },
            {
              name: "Tube one option three",
              value: "blue",
              checked: false,
              label: "Blue",
              style: {
                backgroundColor: "#041f5c",
                color: "white",
              },
            },
          ],
          feedback: {
            showFeedback: false,
          },
        },
        {
          optionLabel: "",
          optionTube: {
            type: "GLASS_TUBE",
            solution: "#4a663c",
            stopperId: 1,
            tubeLabel: "2",
            boxId: 1,
          },
          checkboxes: [
            {
              name: "Tube two option one",
              value: "green",
              checked: false,
              label: "Green",
              style: {
                backgroundColor: "#4a663c",
                color: "white",
              },
            },
            {
              name: "Tube two option two",
              value: "yellow",
              checked: false,
              label: "Yellow",
              style: {
                backgroundColor: "#d1b93d",
                color: "black",
              },
            },
            {
              name: "Tube two option three",
              value: "blue",
              checked: false,
              label: "Blue",
              style: {
                backgroundColor: "#041f5c",
                color: "white",
              },
            },
          ],
          feedback: {
            showFeedback: false,
          },
        },
        {
          optionLabel: "",
          optionTube: {
            type: "GLASS_TUBE",
            solution: "#4a663c",
            stopperId: 1,
            tubeLabel: "3",
            plantId: 0,
          },
          checkboxes: [
            {
              name: "Tube three option one",
              value: "green",
              checked: false,
              label: "Green",
              style: {
                backgroundColor: "#4a663c",
                color: "white",
              },
            },
            {
              name: "Tube three option two",
              value: "yellow",
              checked: false,
              label: "Yellow",
              style: {
                backgroundColor: "#d1b93d",
                color: "black",
              },
            },
            {
              name: "Tube three option three",
              value: "blue",
              checked: false,
              label: "Blue",
              style: {
                backgroundColor: "#041f5c",
                color: "white",
              },
            },
          ],
          feedback: {
            showFeedback: false,
          },
        },
        {
          optionLabel: "",
          optionTube: {
            type: "GLASS_TUBE",
            solution: "#4a663c",
            stopperId: 1,
            tubeLabel: "4",
            plantId: 0,
            boxId: 1,
          },
          checkboxes: [
            {
              name: "Tube four option one",
              value: "green",
              checked: false,
              label: "Green",
              style: {
                backgroundColor: "#4a663c",
                color: "white",
              },
            },
            {
              name: "Tube four option two",
              value: "yellow",
              checked: false,
              label: "Yellow",
              style: {
                backgroundColor: "#d1b93d",
                color: "black",
              },
            },
            {
              name: "Tube four option three",
              value: "blue",
              checked: false,
              label: "Blue",
              style: {
                backgroundColor: "#041f5c",
                color: "white",
              },
            },
          ],
          feedback: {
            showFeedback: false,
          },
        },
      ],
      feedbackType: "",
      submitted: false,
    },
    interactionProps: {
      glassTubes: [
        {
          id: 1,
          type: "Glass Tube",
          plantId: -1,
          stopperId: -1,
          boxId: -1,
          plantIdBackup: -1,
          stopperIdBackup: -1,
          boxIdBackup: -1,
          solution: "#4A663C",
          solutions: {
            BTB: {
              pH: 7,
              volume: 1000,
            },
          },
          tubeLabel: "1",
          tooltipLabel: "Glass Tube 1",
          volume: 1000,
        },
        {
          id: 2,
          type: "Glass Tube",
          plantId: -1,
          stopperId: -1,
          boxId: -1,
          plantIdBackup: -1,
          stopperIdBackup: -1,
          boxIdBackup: -1,
          solution: "#4A663C",
          solutions: {
            BTB: {
              pH: 7,
              volume: 1000,
            },
          },
          tubeLabel: "2",
          tooltipLabel: "Glass Tube 2",
          volume: 1000,
        },
        {
          id: 3,
          type: "Glass Tube",
          plantId: -1,
          stopperId: -1,
          boxId: -1,
          plantIdBackup: -1,
          stopperIdBackup: -1,
          boxIdBackup: -1,
          solution: "#4A663C",
          solutions: {
            BTB: {
              pH: 7,
              volume: 1000,
            },
          },
          tubeLabel: "3",
          tooltipLabel: "Glass Tube 3",
          volume: 1000,
        },
        {
          id: 4,
          type: "Glass Tube",
          plantId: -1,
          stopperId: -1,
          boxId: -1,
          plantIdBackup: -1,
          stopperIdBackup: -1,
          boxIdBackup: -1,
          solution: "#4A663C",
          solutions: {
            BTB: {
              pH: 7,
              volume: 1000,
            },
          },
          tubeLabel: "4",
          tooltipLabel: "Glass Tube 4",
          volume: 1000,
        },
      ],
    },
    level: 1,
  };
}

function mapDispatchToProps() {
  return {};
}

export const ResultsComparisonPhotosynthesis = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
